import React from "react";
import Accord from "../../../assets/accord.svg";
import Certificate from "../../../assets/certificate.svg";
import Connect from "../../../assets/connect.svg";
import Consent from "../../../assets/consent.svg";
import Cte from "../../../assets/cte.svg";
import Dte from "../../../assets/dte.svg";
import GetData from "../../../assets/getdata.svg";
import Invoice from "../../../assets/invoice.svg";
import Lendbot from "../../../assets/lendbot.svg";
import Vizdata from "../../../assets/vizdata.svg";
import Rules from "../../../assets/rules.svg";
import Sii from "../../../assets/sii.svg";
import Tou from "../../../assets/tou.svg";
import Aec from "../../../assets/aec.svg";
import Dealernet from "../../../assets/dealernet.svg";
import Dj from "../../../assets/dj.svg";
import Empresa from "../../../assets/empresa.svg";
import Equifax from "../../../assets/equifax.svg";
import Fogape from "../../../assets/fogape.svg";
import Jscypher from "../../../assets/jscipher.svg";
import PerfilFinanciero from "../../../assets/perfil-financiero.svg";
import Sbif from "../../../assets/sbif.svg";
import Sinacofi from "../../../assets/sinacofi.svg";
import Tgr from "../../../assets/tgr.svg";
import AccordTexto from "../../../assets/logo-herramienta/accord-texto.svg";
import ConnectTexto from "../../../assets/logo-herramienta/connect-texto.svg";
import ConsentTexto from "../../../assets/logo-herramienta/consent-texto.svg";
import GetDataTexto from "../../../assets/logo-herramienta/getdata-texto.svg";
import LendbotTexto from "../../../assets/logo-herramienta/lendbot-texto.svg";
import VizdataTexto from "../../../assets/logo-herramienta/vizdata-texto.svg";
import RulesTexto from "../../../assets/logo-herramienta/fleet-texto.svg";
import TouTexto from "../../../assets/logo-herramienta/tou-texto.svg";
import DatamartLogoAdmin from "../../../assets/datamart-logo-admin.svg";
import DatamartLogo from "../../../assets/datamart-logo.svg";
import FaceSignLogo from "../../../assets/facesign-logo.svg";

export default function DmImageSrc(icon) {
  switch (icon) {
    case "Accord":
      return Accord;
    case "Connect":
      return Connect;
    case "Certificate":
      return Certificate;
    case "Consent":
      return Consent;
    case "cte":
      return Cte;
    case "dtesync":
      return Dte;
    case "GetData":
      return GetData;
    case "Invoice":
      return Invoice;
    case "Lendbot":
      return Lendbot;
    case "Vizdata":
      return Vizdata;
    case "Fleet":
      return Rules;
    case "Sii":
      return Sii;
    case "aecsync":
      return Aec;
    case "dealernet":
      return Dealernet;
    case "djsync":
      return Dj;
    case "enterprise":
      return Empresa;
    case "Equifax":
      return Equifax;
    case "fogape":
      return Fogape;
    case "JSCypher":
      return Jscypher;
    case "pfi":
      return PerfilFinanciero;
    case "sbif":
      return Sbif;
    case "sinacofi":
      return Sinacofi;
    case "ToU":
      return Tou;
    case "tgr-sync":
      return Tgr;
    case "AccordTexto":
      return AccordTexto;
    case "ConnectTexto":
      return ConnectTexto;
    case "ConsentTexto":
      return ConsentTexto;
    case "GetDataTexto":
      return GetDataTexto;
    case "LendbotTexto":
      return LendbotTexto;
    case "VizdataTexto":
      return VizdataTexto;
    case "RulesTexto":
      return RulesTexto;
    case "TouTexto":
      return TouTexto;
    case "HomeLogo":
      return DatamartLogo;
    case "AdminLogo":
      return DatamartLogoAdmin;
    case "FaceSignLogo":
      return FaceSignLogo;
    default:
      return "";
  }
}
